import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import axios from 'axios'
import { MapContainer, CircleMarker, TileLayer, Popup, LayersControl, LayerGroup } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import MarkerClusterGroup from "react-leaflet-cluster"
import CtrlScrollZoom from './ctrl_scroll_zoom'

const PublicServicesMap = props => {
  const [filter, setFilter] = useState({ service_type_id: null })
  const [subjects, setSubjects] = useState([])
  const [legendEl, setLegendEl] = useState(null)

  useEffect(() => {
    setLegendEl(document.getElementById('help-map-legend'))
  }, [])

  useEffect(() => {
    setSubjects([])

    axios.post(props.areas_url, {
      ...filter
    })
      .then(function (response) {
        setSubjects(response.data.subjects)
      })
      .catch(function (error) {
        console.log(error);
      })
  }, [filter])

  const renderServicesFromArea = subject => {
    let arr = []

    subject.services.map((service, index) => (
      arr.push(renderMarkers(service, service.coords, `service-${service.id}-${index}`, subject.color))
    ))

    // area.services.map(service => (
    //   arr.push(renderMarkers(service, service.api_addresses_reverse, 'address', area.color))
    // ))
    // area.services.map(service => (
    //   arr.push(renderMarkers(service, service.api_localities_reverse, 'locality', area.color))
    // ))
    return arr.flat(1)
  }

  const renderAreas = () => {
    return subjects.map((subject, index) => (
      <LayersControl.Overlay name={subject.name} checked key={index}>
        <MarkerClusterGroup chunkedLoading animate={true} key={index}>
          <LayerGroup>
            {renderServicesFromArea(subject)}
          </LayerGroup>
        </MarkerClusterGroup>
      </LayersControl.Overlay>
    ))
  }

  const renderMarkers = (service, coords, type, marker_color) => {
    if (coords.length > 0) {
      return (
        <CircleMarker
          key={type}
          fillColor={marker_color}
          fillOpacity={1.0}
          weight={3}
          center={coords}
          radius={10}
          color={marker_color}
        >
          <Popup>
            <h5>{service.name}</h5>
            <p>
              <strong>{I18n.t('services.service_content.contact')}: </strong>
              {service.address}
            </p>
            <p>
              <strong>{I18n.t('activerecord.attributes.service.contact_phone')}: </strong>
              {service.contact_phone}
            </p>
            <p>
              <strong>{I18n.t('activerecord.attributes.service.contact_email')}: </strong>
              {service.contact_email}
            </p>
            <p>
              <strong>{I18n.t('activerecord.attributes.service.company_id')}: </strong>
              <a href={`/sit/organizace/${service.company_id}`}>{service.company}</a>
            </p>
            <p><a href={`/sit/sluzby/${service.id}`}>{I18n.t('services.service_content.more')}</a></p>
          </Popup>
        </CircleMarker>
      )
    }
  }

  const badgeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.375rem 0.75rem',
    borderRadius: '9999px',
    background: '#fff',
    border: '1px solid #e5e7eb',
    fontSize: '0.875rem',
    fontWeight: 600,
    color: '#374151',
  }

  const dotStyle = {
    flexShrink: 0,
    width: '0.875rem',
    height: '0.875rem',
    borderRadius: '9999px',
  }

  const renderLegend = () => (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
      {subjects.map(subject =>
        <span key={subject.name} style={badgeStyle}>
          <span style={{ ...dotStyle, background: subject.color }} />
          {subject.name}
        </span>
      )}
    </div>
  )

  return (
    <>
      <MapContainer
        center={[49.9497244, 15.7950577]}
        zoom={15}
        scrollWheelZoom={false}
        preferCanvas={false}
        style={{ height: '22rem', width: '100%' }}
      >
        <CtrlScrollZoom />
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

        <LayersControl position="topright">
          {subjects && renderAreas()}
        </LayersControl>
      </MapContainer>

      {legendEl && createPortal(renderLegend(), legendEl)}
    </>
  )
}

export default PublicServicesMap;